// removed by extract-text-webpack-plugin
module.exports = {"notification":"notification___3ggPz","icon":"icon___3gY7U"};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/userrequestListColumns.module.scss
// module id = 2307
// module chunks = 0